// VistaDia.jsx
import React, { useState, useEffect } from "react";
import moment from "moment";
import PreviewDayModal from "./PreviewDayModal";

const VistaDia = ({ events, currentDate, onEditEvent, onDeleteEvent }) => {
  const selectedDate = currentDate;
  const hours = Array.from({ length: 25 }, (_, i) => `${i}:00`);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [ctxMenu, setCtxMenu] = useState({
    visible: false,
    x: 0,
    y: 0,
    event: null,
  });

  useEffect(() => {
    const close = () =>
      setCtxMenu((p) => (p.visible ? { ...p, visible: false } : p));
    window.addEventListener("click", close);
    window.addEventListener("scroll", close, true);
    return () => {
      window.removeEventListener("click", close);
      window.removeEventListener("scroll", close, true);
    };
  }, []);

  const handleEventClick = (ev) => {
    setSelectedEvent(ev);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedEvent(null);
  };

  /* Paleta por tipo -------------------------------------------------- */
  const resourceStyles = {
    cotizacion: { bg: "bg-blue-100", text: "text-blue-800" },
    evento: { bg: "bg-green-100", text: "text-green-800" },
    festivo: { bg: "bg-red-100", text: "text-red-800" },
  };

  /* Eventos del día ordenados ---------------------------------------- */
  const dayEvents = events
    .filter((ev) => moment(ev.start).isSame(selectedDate, "day"))
    .sort((a, b) => moment(a.start).diff(moment(b.start)));

  return (
    <div className="flex h-screen bg-gray-50">
      <div className="flex-1 bg-white rounded-lg shadow overflow-hidden flex flex-col">
        {/* Cabecera ---------------------------------------------------- */}
        <div className="p-6 flex justify-center border-b">
          <h1 className="text-2xl font-bold text-gray-600 capitalize">
            {selectedDate.format("dddd, D")}
          </h1>
        </div>

        {/* Línea de tiempo -------------------------------------------- */}
        <div className="flex-1 overflow-y-auto">
          {hours.map((hour, idx) => {
            const numericHour = parseInt(hour, 10);

            /* Sólo eventos que *empiezan* en esta hora ----------------*/
            const evs = dayEvents.filter(
              (ev) => moment(ev.start).hour() === numericHour
            );

            return (
              <div key={hour} className="relative border-b border-gray-200">
                {/* Línea vertical fija --------------------------------*/}
                <span className="absolute left-16 top-0 h-full w-px bg-gray-200" />

                {/* Columna hora / icono --------------------------------*/}
                <div className="flex">
                  <div className="flex-none w-14 pr-2 text-right pt-2">
                    {idx === 0 ? (
                      <i className="bi bi-clock text-[1.875rem] text-gray-500" />
                    ) : (
                      <span className="text-gray-500">{hour}</span>
                    )}
                  </div>

                  {/* Contenedor de eventos ----------------------------*/}
                  <div className="flex-1 pl-6 pr-2 py-2">
                    {evs.map((ev) => {
                      const { bg, text } = resourceStyles[ev.resource] || {
                        bg: "bg-gray-200",
                        text: "text-gray-800",
                      };
                      const customBg = ev.resource === "tarea" ? ev.color : "";
                      const start = moment(ev.start).format("h:mm A");
                      const end = moment(ev.end).format("h:mm A");

                      return (
                        <div
                          key={ev.id}
                          className={`${bg} ${text} flex justify-between items-center px-6 py-2 rounded-md shadow-sm mb-2 mt-2 cursor-pointer`}
                          style={{ backgroundColor: customBg || undefined }}
                          onClick={() => handleEventClick(ev)}
                          onContextMenu={(e) => {
                            e.preventDefault();
                            // calculamos posición con un pequeño padding
                            const P = 8;
                            let x = e.clientX + P;
                            let y = e.clientY + P;
                            const M_W = 150;
                            const M_H = 64; // 2 filas * 32 px
                            if (x + M_W > window.innerWidth)
                              x = e.clientX - M_W - P;
                            if (y + M_H > window.innerHeight)
                              y = e.clientY - M_H - P;
                            setCtxMenu({ visible: true, x, y, event: ev });
                          }}
                        >
                          <span className="font-semibold truncate">
                            {ev.title}
                          </span>
                          <span className="text-xs font-bold whitespace-nowrap">
                            {`${start} – ${end}`}
                          </span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {ctxMenu.visible && (
        <div
          className="fixed bg-white border border-gray-300 shadow-lg z-50 divide-y divide-gray-100 rounded-lg overflow-hidden w-36"
          style={{ top: ctxMenu.y, left: ctxMenu.x }}
          onClick={(e) => e.stopPropagation()}
          onContextMenu={(e) => e.preventDefault()}
        >
          <button
            className="w-full px-4 py-2 text-sm text-left hover:bg-gray-100 flex items-center gap-2"
            onClick={() => {
              onEditEvent && onEditEvent(ctxMenu.event);
              setCtxMenu((p) => ({ ...p, visible: false }));
            }}
          >
            <i className="bi bi-pencil-fill" />
            Editar
          </button>

          <button
            className="w-full px-4 py-2 text-sm text-left text-red-600 hover:bg-gray-100 flex items-center gap-2"
            onClick={() => {
              onDeleteEvent && onDeleteEvent(ctxMenu.event);
              setCtxMenu((p) => ({ ...p, visible: false }));
            }}
          >
            <i className="bi bi-trash-fill" />
            Eliminar
          </button>
        </div>
      )}

      <PreviewDayModal
        isOpen={isModalOpen}
        onClose={closeModal}
        event={selectedEvent}
      />
    </div>
  );
};

export default VistaDia;
